<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />
      <div class="card">
        <div class="title">Laporan Usia Barang Per Kode Barang</div>
        <DataTable
          :value="items"
          :paginator="true"
          :loading="loading"
          class="p-datatable-outlets"
          :rows="30"
          :rowHover="true"
          :scrollable="true"
          :lazy="true"
          :totalRecords="total_records"
          scrollDirection="horizontal"
          @page="getItemsAge($event)"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col" style="margin-top: 2.2rem">
                <AutoComplete
                  placeholder="Pilih tipe"
                  id="type"
                  :dropdown="true"
                  :multiple="false"
                  v-model="selectedType"
                  :suggestions="autoFiltered"
                  @complete="searchType($event)"
                  field="name"
                />
              </div>
              <div class="p-col" style="margin-top: 2.2rem">
                <Button
                  label="Cari"
                  class="p-button-primary"
                  icon="pi pi-search"
                  @click="getItemsAge()"
                />
              </div>
              <div
                class="p-col"
                style="margin-top: 2.2rem"
                v-if="items != null"
              >
                <router-link
                  :to="{
                    name: 'print-report-items-age',
                    query: {
                      outlet_id: user.outlet_id,
                      age: age,
                      limit: total_records
                    }
                  }"
                  target="_blank"
                >
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                  />
                </router-link>
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading>Mengambil data barang. Mohon tunggu</template>

          <Column header="No" headerStyle="text-align: center; width: 10rem">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.no | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Kode barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.item_code }}
              </div>
            </template>
          </Column>
          <Column
            header="Nama Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.item_name }}
              </div>
            </template>
          </Column>
          <Column header="Qty" headerStyle="text-align: center; width: 10rem">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stock | number }}
              </div>
            </template>
          </Column>
          <Column header="Usia" headerStyle="text-align: center; width: 10rem">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.age }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: true,
      expandedRows: [],
      items: null,
      total_records: 0,
      selectedType: '<3b',
      selectedTypes: [
        { id: 1, code: '<3b', name: 'Usia < 3 bulan' },
        { id: 2, code: '3b-6b', name: 'Usia 3 - 6 bulan' },
        { id: 3, code: '6b-1th', name: 'Usia 6 bulan - 1 tahun' },
        { id: 4, code: '>1th', name: 'Usia > 1 tahun' }
      ],
      autoFiltered: [],
      limit: 30,
      age: ''
    }
  },
  mounted() {
    this.getAuthUser()
    this.getItemsAge()
  },

  methods: {
    getAuthUser() {
      console.info(this.user)
    },

    searchType(event) {
      this.autoFiltered = this.selectedTypes.filter(item => {
        return (
          item.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
          item.code.toLowerCase().startsWith(event.query.toLowerCase())
        )
      })
    },

    async getItemsAge(event) {
      this.loading = true
      let page = 1
      if (event) {
        page = event.page + 1
      }

      if (typeof this.selectedType !== 'object') {
        this.age = '<3b'
      } else {
        this.age = this.selectedType.code
      }

      if (!this.age) {
        this.showToast('error', 'Error', 'Pilih tipe terlebih dahulu')
        this.loading = false
        return
      }

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/report-items-age?code=&name=&age=${this.age}&page=${page}&limit=${this.limit}`
        )

        if (response.status === 200) {
          this.items = response.data.data.outlet_inbounds
          this.total_records = response.data.data.total
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } catch (error) {
        this.showToast(
          'error',
          'Error',
          'Terjadi kesalahan saat mengambil data'
        )
      } finally {
        this.loading = false
      }
    },

    closeDialog() {
      this.confirmDialog = false
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
